var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbsRowMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 65,
    viewBox: "0 0 435 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.387 10C383.387 39.5002 129.887 61.5002 7.38745 10.0001",
    stroke: "#431C2B",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3874 27.3598C60.3874 30.8722 63.2348 33.7195 66.7472 33.7195C70.2596 33.7195 73.1069 30.8722 73.1069 27.3598C73.1069 23.8474 70.2596 21 66.7472 21C63.2348 21 60.3874 23.8474 60.3874 27.3598Z",
    fill: "url(#paint0_radial_1021_39332)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3874 12.3598C11.3874 15.8722 14.2348 18.7195 17.7472 18.7195C21.2596 18.7195 24.1069 15.8722 24.1069 12.3598C24.1069 8.84736 21.2596 6 17.7472 6C14.2348 6 11.3874 8.84736 11.3874 12.3598Z",
    fill: "url(#paint1_radial_1021_39332)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.387 35.3598C111.387 38.8722 114.235 41.7195 117.747 41.7195C121.26 41.7195 124.107 38.8722 124.107 35.3598C124.107 31.8474 121.26 29 117.747 29C114.235 29 111.387 31.8474 111.387 35.3598Z",
    fill: "url(#paint2_radial_1021_39332)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.388 40.3598C172.388 43.8722 175.235 46.7195 178.747 46.7195C182.26 46.7195 185.107 43.8722 185.107 40.3598C185.107 36.8474 182.26 34 178.747 34C175.235 34 172.388 36.8474 172.388 40.3598Z",
    fill: "url(#paint3_radial_1021_39332)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.388 40.3598C233.388 43.8722 236.235 46.7195 239.747 46.7195C243.26 46.7195 246.107 43.8722 246.107 40.3598C246.107 36.8474 243.26 34 239.747 34C236.235 34 233.388 36.8474 233.388 40.3598Z",
    fill: "url(#paint4_radial_1021_39332)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.388 37.3597C287.388 40.8721 290.235 43.7195 293.747 43.7195C297.26 43.7195 300.107 40.8721 300.107 37.3597C300.107 33.8473 297.26 31 293.747 31C290.235 31 287.388 33.8473 287.388 37.3597Z",
    fill: "url(#paint5_radial_1021_39332)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.388 31.3597C341.388 34.8721 344.235 37.7195 347.747 37.7195C351.26 37.7195 354.107 34.8721 354.107 31.3597C354.107 27.8473 351.26 25 347.747 25C344.235 25 341.388 27.8473 341.388 31.3597Z",
    fill: "url(#paint6_radial_1021_39332)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1021_39332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.387 21.3597C390.387 24.8721 393.235 27.7195 396.747 27.7195C400.26 27.7195 403.107 24.8721 403.107 21.3597C403.107 17.8473 400.26 15 396.747 15C393.235 15 390.387 17.8473 390.387 21.3597Z",
    fill: "url(#paint7_radial_1021_39332)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1021_39332",
    x: 0,
    y: 8.07837,
    width: 434.944,
    height: 46.8379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0392157 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1021_39332",
    x: 54.3875,
    y: 15,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1021_39332",
    x: 5.38745,
    y: 0,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1021_39332",
    x: 105.387,
    y: 23,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1021_39332",
    x: 166.388,
    y: 28,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1021_39332",
    x: 227.388,
    y: 28,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1021_39332",
    x: 281.388,
    y: 25,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1021_39332",
    x: 335.388,
    y: 19,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1021_39332",
    x: 384.387,
    y: 9,
    width: 24.7195,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_39332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.7472 27.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7472 12.3598) rotate(180) scale(7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.747 35.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.747 40.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.747 40.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.747 37.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(347.747 31.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1021_39332",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(396.747 21.3598) rotate(180) scale(7.72257 7.72257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbsRowMob);
export default __webpack_public_path__ + "static/media/lightbulbs-row-mob.3dc5b2155ebdb6286c40a386eb757433.svg";
export { ForwardRef as ReactComponent };